import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import { BatchHttpLink } from "apollo-link-batch-http";
import { setContext } from "apollo-link-context";
import {
  IntrospectionFragmentMatcher,
  InMemoryCache,
} from "apollo-cache-inmemory";
import { getConfig } from "@nested/config";

import schema from "../../../../schema.json";

const { GRAPHQL_URI } = getConfig();

const httpLink = new BatchHttpLink({
  uri: GRAPHQL_URI,
});

// Apollo and Absinthe have a different protocol resulting in a different and invalid format for ApolloCache
export const absintheAfterware = new ApolloLink((operation, forward) =>
  forward(operation).map((response) => ({
    ...response,
    ...response.payload,
  })),
);

export const authLink = setContext(async (_, { headers, getToken }) => {
  try {
    const token = getToken && (await getToken());
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  } catch (e) {
    return {};
  }
});

const link = ApolloLink.from([absintheAfterware, authLink, httpLink]);

const getInitialState = () => {
  if (process.browser) {
    return window.APOLLO_STATE;
  }
  return {};
};

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: schema,
});

export const createApolloClient = () =>
  new ApolloClient({
    link,
    cache: new InMemoryCache({ fragmentMatcher }).restore(getInitialState()),
  });
